/**
 * Shared static mode detection.
 *
 * Static mode = the tenant was pinned at build time (NUXT_TENANT_KEY set), so
 * the SPA calls its backend directly. In dev, the `tr-dev-key` override forces
 * SSR mode so the Nuxt proxy handles auth; `resolveStaticCustomerConfig()`
 * already encodes that precedence.
 */
export function useStaticMode() {
	const staticConfig = resolveStaticCustomerConfig();
	const isStaticMode = !!staticConfig?.apiOrigin;

	const getFullUrl = (url: string) => (isStaticMode ? `${staticConfig!.apiOrigin}${url}` : url);

	return {
		isStaticMode,
		staticConfig,
		getFullUrl,
	};
}
